<template>
    <b-form-group
            :id="'input-group-' + index"
            :label="label"
            :label-for="'input-' + index">
        <b-input-group>
            <b-form-input
                    :class="(error.length > 0) ? 'is-invalid' : ''"
                    :id="'input-' + index"
                    v-model="input"
                    type="text"
                    :style="{ fontSize: font }"
                    :size="size"
                    :required="required"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    @input="run"
                    autocomplete="off" trim>
            </b-form-input>
            <b-input-group-text slot="append">
                <font-awesome-icon :icon="['fal', 'check']" class="text-success" v-if="check"
                                   :style="{ fontSize: font }"/>
                <font-awesome-icon :icon="['fal', 'times']" class="text-danger" v-else/>
            </b-input-group-text>
        </b-input-group>
        <div v-if="error.length > 0">
            <p class="text-danger" v-for="(e,key) in error" v-bind:key="key">{{ e }}</p>
        </div>
    </b-form-group>
</template>

<script>
    export default {
        name: "input-email",
        props: {
            index: {type: Number, default: 1},
            placeholder: {type: String, default: ''},
            label: {type: String, default: ''},
            cols: {type: String, default: ''},
            font: {type: String, default: 'inherit'},
            size: {type: String, default: ''},
            sm: {type: String, default: ''},
            md: {type: String, default: ''},
            lg: {type: String, default: ''},
            xl: {type: String, default: ''},
            offset: {type: String, default: ''},
            disabled: {type: Boolean, default: false},
            value: {default: null},
            hasParent: {default: false},
            parentValue: {default: null},
            required: {type: Boolean, default: false},
            error: {type: Array, default: () => []}
        },
        watch: {
            value(event) {
                this.input = event;
            },
            input() {
                this.handleInput();
            }
        },
        data() {
            return {
                input: '',
                reg: /^[a-zA-Z.\-_]+@[a-zA-Z.\-_]+\.[a-zA-Z]{2,4}$/,
                check: false
            }
        },
        mounted() {
            this.input = this.value;
        },
        methods: {
            run() {
                if (this.hasParent) {
                    this.check = (this.parentValue === this.input);
                    if (this.check) {
                        this.check = this.reg.test(this.input);
                    }
                } else {
                    this.check = this.reg.test(this.input);
                }
                this.handleInput();
            },
            handleInput() {
                this.$emit('update:error', []);
                this.$emit('input', this.input)
            }
        }
    }
</script>

<style scoped>

    .form-control-sm {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
    }

</style>
